//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';
import { useSamplingCampaign } from '@campaigns/hooks/useSamplingCampaign';
import { BodyText, SectionText } from '@components/atoms/text/Text';
import { Modal } from '@components/molecules/modal/Modal';
import RequestModalSuccessIcon from '@images/campaigns/sampling/request-modal-success.svg';
import { isDefined } from '@utils/filterPredicates';

interface PaymentSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const PaymentSuccessModal = ({
  isOpen,
  onClose,
}: PaymentSuccessModalProps) => {
  const { samplingCampaignRequest } = useSamplingCampaign();

  return (
    <Modal
      closeModal={onClose}
      contents={
        <Container>
          <img alt='Success' src={RequestModalSuccessIcon} />
          <ContainerHeader>
            <SectionText>Campaign Payment Processed</SectionText>
            {isDefined(samplingCampaignRequest?.name) && (
              <SectionText>{samplingCampaignRequest?.name}</SectionText>
            )}
          </ContainerHeader>
          <BodyText>
            Your campaign has been requested
            <br />
            We will be in touch with next steps
          </BodyText>
        </Container>
      }
      isFooterEnabled
      isModalOpen={isOpen}
      primaryButtonInfo={{
        buttonContent: 'Close',
        trackingId:
          SAMPLING_CAMPAIGNS_TRACKING_ID.REQUEST_CAMPAIGN_PAYMENT_MODAL_SUCCESS_BUTTON,
        onClick: onClose,
      }}
      shouldIncludeSecondaryButton={false}
      shouldIncludeTertiaryButton={false}
      title=''
      width='wide'
    />
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.echo.spacing.sm};
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const ContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.echo.spacing.sm};
  align-items: center;
  justify-content: center;
`;
